import {AxiosRequestConfig, AxiosResponse} from 'axios';
import {Moment} from 'moment';
import {CareService, UpdateScope} from '../backend/interfaces/care-service';
import {PostCareService} from '../backend/requests/post-care-service';
import {PutCareService} from '../backend/requests/put-care-service';
import {BackendApiManager} from '../managers/backend-api';

export class EntityCareServiceRepository {
  // Singleton Instance
  private static _instance: EntityCareServiceRepository;

  static get instance(): EntityCareServiceRepository {
    if (!this._instance) {
      this._instance = new EntityCareServiceRepository();
    }
    return this._instance;
  }

  public async getCareService(
    entityId: string,
    careServiceId: string,
    options?: AxiosRequestConfig
  ): Promise<CareService> {
    let url: string = `/entities/${entityId}/care-services/${careServiceId}`;

    const result: AxiosResponse<CareService> = await BackendApiManager.instance.get<CareService>(
      url,
      options
    );

    return result.data;
  }

  /** get user's care services */
  public async getItems(
    entityId: string,
    userId: string,
    startDate: Moment,
    endDate: Moment,
    type: 'senior' | 'caregiver' | 'seniors',
    options?: AxiosRequestConfig
  ): Promise<CareService[]> {
    // A)
    // ----- FETCHING FOR A SENIOR -----
    if (type === 'senior') {
      const start = startDate.utc().toISOString();
      const end = endDate.utc().toISOString();
      const seniorIds = [userId].join(',');
      let url: string = `/entities/${entityId}/care-services?startDate=${start}&endDate=${end}&seniorsIds=${seniorIds}`;

      const result: AxiosResponse<CareService[]> = await BackendApiManager.instance.get<
        CareService[]
      >(url, options);

      return result.data;
    }
    // B)
    // ----- FETCHING FOR A CAREGIVER -----
    else if (type === 'caregiver') {
      const start = startDate.utc().toISOString();
      const end = endDate.utc().toISOString();
      const caregiverIds = [userId].join(',');
      let url: string = `/entities/${entityId}/care-services?startDate=${start}&endDate=${end}&caregiversIds=${caregiverIds}`;

      const result: AxiosResponse<CareService[]> = await BackendApiManager.instance.get<
        CareService[]
      >(url, options);

      return result.data;
    }
    // C)
    // ----- FETCHING FOR MULTIPLE SENIORS -----
    else {
      const start = startDate.utc().toISOString();
      const end = endDate.utc().toISOString();
      let url: string = `/entities/${entityId}/care-services?startDate=${start}&endDate=${end}`;

      const result: AxiosResponse<CareService[]> = await BackendApiManager.instance.get<
        CareService[]
      >(url, options);

      return result.data;
    }
  }

  public async create(
    entityId: string,
    userId: string,
    body: PostCareService,
    options?: AxiosRequestConfig
  ): Promise<CareService> {
    let url: string = `/entities/${entityId}/care-services`;

    const result: AxiosResponse<CareService> = await BackendApiManager.instance.post<CareService>(
      url,
      body,
      options
    );

    return result.data;
  }

  public async update(
    entityId: string,
    careServiceId: string,
    body: PutCareService,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<CareService | undefined>> {
    let url: string = `/entities/${entityId}/care-services/${careServiceId}`;

    const result = await BackendApiManager.instance.put<CareService>(url, body, options);

    return result;
  }

  public async delete(
    entityId: string,
    careServiceId: string,
    deletionScope: UpdateScope
  ): Promise<void> {
    let url: string = `/entities/${entityId}/care-services/${careServiceId}`;

    const opts: AxiosRequestConfig = {
      data: {
        deletionScope: deletionScope,
      },
    };

    await BackendApiManager.instance.delete<void>(url, opts);
  }
}
